import {connect} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import "antd/dist/antd.css";
import {
    Button,
    Tooltip,
    Col,
    Form,
    Input,
    Modal,
    Row,
    Space,
    Spin,
    Table,
    Checkbox,
} from "antd";
// import {Link} from "react-router-dom";
import {EditFilled} from "@ant-design/icons";
import {authAxios} from "../utils";
import {
    createBophansudungURL, listBophansudung,
    teamListURL,
    bophansudungURL
} from "../constants";
import {openNotificationWithIcon} from "./Function";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import Cookies from 'universal-cookie';
const cookies = new Cookies


const {Search} = Input

const validateMessages = {
    required: 'Vui lòng nhập ${label} !',
    types: {
        email: '${label} không đúng định dạng email!',
        number: '${label} không phải số!',
    },
    number: {
        range: '${label} must be between ${min} and ${max}',
    },
};
const fetchBophanInfo = (Id) => {
    return authAxios(cookies.get('token'))
        .get(bophansudungURL(Id))
}
// const fetchListTeam = () => {
//     return authAxios(cookies.get('token'))
//         .get(teamListURL)
// }
const editInfo = (newData,dataOld, dataBPSuDung) => {
    var getFilterData = dataBPSuDung.filter(item => item.id !== dataOld.id).filter(item => item.name === newData.tenbophan );
    if (getFilterData.length > 0) {
        openNotificationWithIcon('error','Cảnh báo', "Trùng bộ phận đã có. Yêu cầu kiểm tra lại tên bộ phận.");
        return false
    }

    var FormData = require('form-data')
    var data = new FormData()
    data.append('name', newData.tenbophan)
    data.append('is_active', newData.is_active)

    return authAxios(cookies.get('token'))
        .put(bophansudungURL(dataOld.id),data)
}
const CreateInfo = (newData, dataBPSuDung) => {
    // var getFilterData = dataBPSuDung.filter(item => item.id !== newData.id).filter(item => item.username === newDataUser.tendangnhap || item.msnv === newDataUser.msnv || item.email === newDataUser.email);
    var getFilterData = dataBPSuDung.filter(item => item.name === newData.tenbophan );
    if (getFilterData.length > 0) {
        openNotificationWithIcon('error','Cảnh báo', "Trùng bộ phận đã có. Yêu cầu kiểm tra lại tên bộ phận.");
        return false
    }

    var FormData = require('form-data');
    var data = new FormData();
    data.append('name', newData.tenbophan)
    data.append('is_active', true)
    return authAxios(cookies.get('token'))
        .post(createBophansudungURL,data)
        .then(res => {
            if (res.data.error) {
                const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
                openNotificationWithIcon('error','Lỗi', dataError)
                return false
            }
        })
        .catch(err => {
            openNotificationWithIcon('error','Lỗi', err)
            return false
        })
}
async function waitForBophanInfo(Id) {
    let getBophanInfo = await fetchBophanInfo(Id);
    // let listTeam = await fetchListTeam();
    let listTeam = [];
    return [getBophanInfo,listTeam]
}
async function waitForeditInfo(newData,dataOld, dataBPSuDung) {
    let res = await editInfo(newData,dataOld, dataBPSuDung);
    return res
}

async function waitForCreateInfo(newData, dataBPSuDung) {
    let res = await CreateInfo(newData, dataBPSuDung);
    return res
}
const useResetFormOnCloseModal = ({form, visible}) => {
    const prevVisibleRef = useRef();
    useEffect(() => {
        prevVisibleRef.current = visible;
    }, [visible]);
    const prevVisible = prevVisibleRef.current;
    useEffect(() => {
        if (!visible && prevVisible) {
            form.resetFields();
        }
    }, [visible]);
};
const ModalFormCreate = ({visible, onCancel}) => {
    const [form] = Form.useForm();
    const [loadingModal, setLoadingModal] = useState(false)
    useResetFormOnCloseModal({
        form,
        visible,
    });

    const onFinish = (values) => {
        authAxios(cookies.get('token'))
        .get(listBophansudung, {params: {}})
        .then(res => {
            waitForCreateInfo(values, res.data.results)
            .then(res => {
                if (res != false){
                    onCancelModal(true)
                }
                // if (res.data.error) {
                //     console.log(123);
                //     const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
                //     openNotificationWithIcon('error','Lỗi', dataError)
                // }
                // else {
                //    onCancelModal(true)
                // }
                setLoadingModal(false)
            })
            .catch(err => {
                openNotificationWithIcon('error','Lỗi', err)
            })
        })
        .catch(err => {
        });

    }
    const onOk = () => {
        setLoadingModal(true)
        form.submit();
    };
    const onFinishFailed = () => {
        setLoadingModal(false)
    };
    const onCancelModal = (value) => {
        onCancel(value);
    };
    return (
        <Modal title="Tạo bộ phận sử dụng mới" visible={visible} okText="Lưu" onOk={onOk} onCancel={onCancelModal} forceRender>
            <Spin spinning={loadingModal}>
                <Form form={form} layout="vertical" name="userFormCreate" validateMessages={validateMessages}
                      onFinish={onFinish} onFinishFailed={onFinishFailed}>
                    <Row>
                        <Col sm={10} offset={1}>
                            <Form.Item
                                name="tenbophan"
                                label="Tên bộ phận"
                                rules={[
                                    {required: true},
                                ]}
                            >
                                <Input placeholder="Nhập tên bộ phận"/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </Modal>
    );
};

const ModalFormEdit = ({visible, onCancel,dataBophanEdit}) => {
    const [form] = Form.useForm();
    const [loadingModal, setLoadingModal] = useState(false)
    const [isActive, setIsActive] = useState(true)
    useResetFormOnCloseModal({
        form,
        visible,
    });
    const onFinish = (values) => {
        authAxios(cookies.get('token'))
        .get(listBophansudung, {params: {}})
        .then(res => {
            waitForeditInfo(values, dataBophanEdit, res.data.results)
            .then(res => {
                // res == false ? null : onCancelModal(true)
                if (res != false) {
                    onCancelModal(true)
                }
                // if (res.data.error) {
                //     console.log(123);
                //     const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
                //     openNotificationWithIcon('error','Lỗi', dataError)
                // }
                // else {
                //    onCancelModal(true)
                // }
                setLoadingModal(false)
            })
            .catch(err => {
                openNotificationWithIcon('error','Lỗi', err)
            })
        })
        .catch(err => {
        });
    }
    useEffect(() => {
        setIsActive(dataBophanEdit.is_active)
        form.setFieldsValue({
            tenbophan:dataBophanEdit.name,
            is_active:dataBophanEdit.is_active,
        })
    },[dataBophanEdit])
    const onOk = () => {
        setLoadingModal(true)
        form.submit();
    };
    const onFinishFailed = () => {
        setLoadingModal(false)
    };
    const onCancelModal = (value) => {
        onCancel(value);
    };
    const setActive = (e) => {
        setIsActive(e.target.checked)
        form.setFieldsValue({
            is_active:e.target.checked
        })
    };
    return (
        <Modal title="Chỉnh sửa thông tin bộ phận" visible={visible} onOk={onOk} onCancel={onCancelModal} forceRender>
            <Spin spinning={loadingModal}>
                <Form form={form} layout="vertical" name="userFormEdit" validateMessages={validateMessages}
                      onFinish={onFinish} onFinishFailed={onFinishFailed}>
                    <Row>
                        <Col sm={10} offset={1}>
                            <Form.Item
                                name="tenbophan"
                                label="Tên bộ phận"
                                rules={[
                                    {required: true},
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                            <Form.Item
                        name="is_active"
                        label="Kích hoạt"
                    >
                        <Checkbox defaultChecked={dataBophanEdit.is_active} checked={isActive} onChange={(e) => setActive(e)}/>
                    </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </Modal>
    );
};

class SettingsUsers extends React.Component {
    state = {
        filteredInfo: null,
        sortedInfo: null,
        data: [],
        total_page: '',
        pagination: {pageSize: 10},
        visibleFormEditUserModal: false,
        visibleFormSetPermissionUserModal: false,
        idUserEdit: '',
        dataBophanEdit: '',
    };
    componentDidMount() {
        // this.setState({loading: true});
        this.fetchListBpsd(
            {
                page_size: this.state.pagination.pageSize,
                page: 1,
                columnSort: 'id',
                typeSort: 'descend',
            });
    }
    handleChange = (pagination, filters, sorter, extra) => {
        this.setState({loading: true})
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.setState({
            pagination: pager,
        });
        this.fetchListBpsd({
            page_size: pagination.pageSize,
            page: pagination.current,
            columnSort: sorter.field || 'id',
            typeSort: sorter.order || 'descend',
            search: this.state.searchKey,
            ...filters,
        })

    };
    fetchListBpsd = (params = {}) => {
        this.setState({loading: true})
        authAxios(cookies.get('token'))
            .get(listBophansudung, {params: params})
            .then(res => {
                this.setState({data: res.data.results, loading: false, total_page: res.data.count});
            })
            .catch(err => {
                this.setState({error: err, loading: false});
                if (err.response.status === 401) {
                    this.props.history.push('/login');
                }
            });
    };
    SearchList = (value, event) => {
        // let {sortKey, sortDirection, pageSize} = this.state;
        const pager = {...this.state.pagination};
        pager.current = 1;
        pager.page = 1;
        this.setState({searchKey: value, pagination: pager})
        this.fetchListBpsd({
            page_size: this.state.pagination.pageSize,
            page: 1,
            // columnSort: 'id',
            typeSort: 'ascend',
            search: value,
        })
    }
    clearFilters = () => {
        this.setState({filteredInfo: null});
    };
    editInfo = (idBophan) => {
        waitForBophanInfo(idBophan).then(res => {
            this.setState({idBophanEdit: idBophan,dataBophanEdit:res[0].data,listTeam:res[1].data,visibleFormEditModal:true})
        })
    }
    showCreateModal = () => {
        this.setState({visibleFormCreateModal:true})
    }

    hideEditModal = (value) => {
        this.setState({idBophanEdit: '', visibleFormEditModal: false,dataBophanEdit:''})
        if (value === true) {
            this.fetchListBpsd(
                {
                page_size: this.state.pagination.pageSize,
                page: 1,
                columnSort: 'id',
                typeSort: 'descend',
            }
            )
            openNotificationWithIcon('success','Thành công','Cập nhật thông tin bộ phận ')
        }
    }

    hideCreateModal = (value) => {
        this.setState({visibleFormCreateModal: false})
        if (value === true) {
            this.fetchListBpsd({
                page_size: this.state.pagination.pageSize,
                page: 1,
                columnSort: 'id',
                typeSort: 'descend',
            })
            openNotificationWithIcon('success','Thành công','Tạo mới bộ phận ')
        }
    }

    render() {
        let {loading, data, total_page, pagination, visibleFormEditModal,visibleFormCreateModal} = this.state;
        const columns = [
            {
                title: "STT",
                dataIndex: "id",
                key: "index",
                render: (value, item, index) => ((pagination.current || 1) - 1) * pagination.pageSize + index + 1,
                sorter: (a, b) => a.id - b.id,
                sortDirections: ['descend', 'ascend', 'descend'],
            },
            {
                title: "Tên bộ phận",
                dataIndex: "name",
                key: "name",
                sorter: (a) => a,
            },

            {
                title: 'Trạng thái',
                dataIndex: 'is_active',
                key: 'is_active',
                render: (text) => (text ? 'Kích hoạt' : 'Khóa'),
            },
            {
                title: 'Thao tác',
                key: 'operation',
                render: (text, record) => (
                    <Space size="middle">
                        <Tooltip placement="bottomRight" title={"Chỉnh sửa thông tin bộ phận sử dụng"}>
                        <Button onClick={() => this.editInfo(record.id)} type={'primary'}><EditFilled/></Button>
                        </Tooltip>
                    </Space>
                )
            },


        ];
        return (
            <>
                <Row>
                    <Col sm={14} style={{float: 'left'}}>
                        <Button type={'danger'} style={{marginBottom: 15}} onClick={this.showCreateModal}>
                            <PlusOutlined/> Thêm bộ phận mới
                        </Button>
                    </Col>
                    <Col sm={10} style={{float: 'right'}}>
                        <Search placeholder="Nhập từ khóa tìm kiếm" enterButton="Tìm kiếm" size="normal"
                                onSearch={this.SearchList}/>
                    </Col>
                </Row>
                <Table
                    dataSource={data}
                    columns={columns}
                    loading={loading}
                    bordered={true}
                    rowKey="id"
                    onChange={this.handleChange}
                    pagination={{
                        current: this.state.pagination.current,
                        pageSize: this.state.pagination.pageSize,
                        total: total_page,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['10', '15', '25', '50']
                    }}
                />
                <ModalFormEdit
                    visible={visibleFormEditModal}
                    onCancel={this.hideEditModal}
                    dataBophanEdit={this.state.dataBophanEdit}
                    // listTeam={this.state.listTeam}
                />
                <ModalFormCreate
                    visible={visibleFormCreateModal}
                    onCancel={this.hideCreateModal}
                />
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null
    };
};
export default connect(mapStateToProps)(SettingsUsers);


